import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Link from 'flarum/common/components/Link';
import stringToColor from 'flarum/common/utils/stringToColor';
import { ladderApi, money, unit } from '../../common/api';
const t = function (name, params) {
  if (params === void 0) {
    params = {};
  }
  return app.translator.trans(`ernestdefoe-ladder.forum.members.${name}`, params);
};
/** Who holds one rank, highest score first, thirty at a time. */
export default class RankMembersModal extends Modal {
  members = [];
  total = 0;
  nextOffset = 0;
  loading = false;
  oninit(vnode) {
    super.oninit(vnode);
    this.more();
  }
  className() {
    return 'LadderMembersModal Modal--small';
  }
  title() {
    return this.attrs.rung.name;
  }
  content() {
    const metric = this.attrs.metric;
    return m("div", {
      className: "Modal-body"
    }, this.members.length > 0 && m("ol", {
      className: "LadderMembers"
    }, this.members.map(member => m("li", {
      className: "LadderMembers-item",
      key: member.id
    }, m(Link, {
      href: member.url,
      className: "LadderMembers-link",
      onclick: () => this.hide()
    }, member.avatarUrl ? m("img", {
      className: "Avatar LadderMembers-avatar",
      src: member.avatarUrl,
      alt: "",
      loading: "lazy"
    }) : m("span", {
      className: "Avatar LadderMembers-avatar",
      style: {
        '--avatar-bg': '#' + stringToColor(member.displayName)
      }
    }, member.displayName.charAt(0).toUpperCase()), m("span", {
      className: "LadderMembers-name"
    }, member.displayName), m("span", {
      className: "LadderMembers-score"
    }, app.translator.trans(`ernestdefoe-ladder.forum.members.${unit('score', metric)}`, {
      count: member.score,
      amount: money(member.score)
    })))))), !this.loading && this.members.length === 0 && m("p", {
      className: "LadderMembers-empty"
    }, t('empty')), this.loading ? m(LoadingIndicator, null) : this.nextOffset !== null && m(Button, {
      className: "Button Button--block",
      onclick: () => this.more()
    }, t('more', {
      shown: this.members.length,
      total: this.total
    })));
  }
  more() {
    if (this.nextOffset === null || this.loading) return;
    this.loading = true;
    m.redraw();
    ladderApi('GET', `/rungs/${this.attrs.rung.id}/members`, undefined, {
      params: {
        offset: this.nextOffset
      }
    }).then(page => {
      this.members.push(...page.members);
      this.total = page.total;
      this.nextOffset = page.nextOffset;
    }).catch(() => {
      this.nextOffset = null;
    }).finally(() => {
      this.loading = false;
      m.redraw();
    });
  }
}
flarum.reg.add('ernestdefoe-ladder', 'forum/components/RankMembersModal', RankMembersModal);